import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const symptoms = [
  'mente acelerada que não para',
  'dificuldade para relaxar ou dormir',
  'sensação constante de alerta',
  'cansaço emocional difícil de explicar',
];

export default function EmotionalIdentification() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="py-24 px-6" style={{ background: '#060D18' }}>
      <div
        ref={ref}
        className="max-w-3xl mx-auto"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(28px)',
          transition: 'opacity 0.7s ease, transform 0.7s ease',
        }}
      >
        <div className="text-center mb-12">
          <span
            className="inline-block text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-6 border"
            style={{ background: 'rgba(0,200,232,0.08)', color: '#00C8E8', borderColor: 'rgba(0,200,232,0.2)' }}
          >
            Identificação Emocional
          </span>
          <h2 className="text-3xl md:text-4xl font-semibold leading-tight text-white">
            Talvez você esteja passando por algo assim
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10">
          {symptoms.map((s, i) => (
            <div
              key={i}
              className="flex items-start gap-4 rounded-2xl px-6 py-5 border"
              style={{
                background: '#0F1E30',
                borderColor: 'rgba(0,200,232,0.12)',
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(20px)',
                transition: `opacity 0.6s ease ${0.1 + i * 0.1}s, transform 0.6s ease ${0.1 + i * 0.1}s`,
              }}
            >
              <span
                className="w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5"
                style={{ background: 'rgba(0,200,232,0.1)' }}
              >
                <i className="ri-checkbox-circle-fill text-base" style={{ color: '#00C8E8' }} />
              </span>
              <p className="text-base" style={{ color: '#B8D4E8' }}>{s}</p>
            </div>
          ))}
        </div>

        <div
          className="rounded-2xl px-8 py-8 border text-center"
          style={{ background: 'rgba(15,30,48,0.6)', borderColor: 'rgba(0,200,232,0.15)' }}
        >
          <p className="text-base leading-relaxed mb-4 text-white font-medium">
            Se algo disso faz sentido para você, esta sessão foi criada exatamente para esse momento.
          </p>
          <p className="text-sm leading-relaxed" style={{ color: '#7A9BB5' }}>
            Você não precisa estar no pior momento para começar.<br />
            Muitas pessoas iniciam simplesmente porque perceberam que sua mente não desacelera como antes.
          </p>
        </div>
      </div>
    </section>
  );
}